import { AdFormValues } from 'hooks/useFormUtils';

export const NUM_MAX_CALLOUT_EXTENSIONS_GOOGLE_TEXT = 4;
export const NUM_MAX_SNIPPET_EXTENSIONS_GOOGLE_TEXT = 3;
export const NUM_MAX_LOCATION_EXTENSIONS_GOOGLE_TEXT = 1;
export const NUM_MAX_SITELINK_EXTENSIONS_GOOGLE_TEXT = 4;
export const NUM_MAX_SNIPPET_EXTENSIONS_TEXT_GOOGLE_TEXT = 3;

export interface GoogleTextAdFormValues extends AdFormValues {
  headline1: string;
  headline2: string;
  headline3: string | null;
  description: string;
  description2: string | null;
  destinationUrl: string;
}
